export default {
  checklist: {
    group_checklist_items: [],
    checklist_items: null,
    checklist_users: [],
    quick_reports: [],
    select_status: []
  }
}



// WEBPACK FOOTER //
// ./src/store/module/audit/state.js